import { routeAlias, routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const roleRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.roles,
    name: routeNames.roles,
    component: () => import('@/pages/roles/RolesView.vue'),
    meta: {
      permission: 'roles.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'manage_accounts',
      labelKey: 'roles',
    },
  },
  {
    path: routePaths.roleCreation,
    name: routeNames.roleCreation,
    component: () => import('@/pages/roles/add-edit-role/AddEditRoleView.vue'),
    meta: {
      permission: 'roles.write.all',
      labelKey: 'new_m',
      rootRouteName: routeNames.roles,
    },
  },
  {
    path: routePaths.roleEdit,
    name: routeNames.roleEdit,
    alias: routeAlias.roleEdit,
    component: () => import('@/pages/roles/add-edit-role/AddEditRoleView.vue'),
    meta: {
      permission: 'roles.write.all',
      labelKey: 'edit',
      rootRouteName: routeNames.roles,
    },
  },
]
